import { Table, TableBody } from "@material-ui/core"
import CustomLoader from "../../components/Common/CustomLoader"
import DateInput from "../../components/Common/Inputs/date"
import UsageChart from "./UsageChart"
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Label } from "reactstrap"
import { useEffect, useState } from "react"
import { DropdownIcon, EditIcon, emptyUsageViewIcon } from "../../components/Common/SvgIcons"
import dayjs from 'dayjs';
import config from "../../config"
import moment from "moment";
import { useDispatch, useSelector } from "react-redux"
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { Link, useNavigate } from "react-router-dom"
import { setPayementInformation } from "../../store/actions"
import CustomPopup from "../../components/Common/CustomPopup"

dayjs.extend(utc);
dayjs.extend(timezone);









const UsageTable = ({ loading = false, onInfoChange, usageInfo, usageDetails, tableHeader, handleDurationChange, responseMessage, setDataforExport, appsList }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const today = dayjs();
    const { usageDurationTypes, timeDurationTypes } = config
    const [chartDetails, setChartDetails] = useState({
        listOfFeatures: [],
        FeaturesData: [],
        totalApiCalls: 0,
        tableData: [],
    })
    const [labels, setLabels] = useState([])
    const { selectedTimeZone } = useSelector(state => state.BillSet?.timeZonesDetails)
    const { timezone } = useSelector(state => state.Login.constDetails)
    const [labelsForCsv, setLabelsForCsv] = useState([])
    const ConstDetailsProp = useSelector(state => state.Login.constDetails)
    const { card_setup } = ConstDetailsProp
    const [popupDetails, setPopupDetails] = useState({ open: false })
    const dispatch = useDispatch();
    const navigate = useNavigate();





    useEffect(() => {
        if (usageDetails?.data && !loading) {
            let keys = Object.keys(usageDetails?.count)
            let values = Object.values(usageDetails.data);
            let featureTypes = Object.keys(usageDetails?.count)
            let featureTypesList = usageDetails?.count
            let listofdata = []
            let array = keys;
            const index = array.indexOf('Total Transaction');
            if (index > -1) {
                // Remove the element 'Transaction' from its current position
                const [transaction] = array.splice(index, 1);
                // Push the element 'Transaction' to the end of the array
                array.push(transaction);
            }
            featureTypes.map(ele => {
                let obj = {}
                obj['method'] = ele
                obj['hits'] = featureTypesList[ele]
                obj['from_date'] = usageDetails?.period?.since
                obj['to_date'] = usageDetails?.period?.until
                listofdata.push(obj)
            })
            let tableHeader = ["Date and Time", ...keys]
            let tableData = [labelsForCsv, ...values]
            let arrayOfValues = []
            labels.map((row, rowIndex) => {
                let obj = {}
                tableHeader.map((ele, index) => {
                    obj[ele] = tableData[index][rowIndex]
                })
                arrayOfValues.push(obj)

            })

            setDataforExport({ header: tableHeader.map(ele => { return { title: ele, value: ele } }), data: arrayOfValues })
            setChartDetails({ listOfFeatures: array, FeaturesData: values, totalApiCalls: usageDetails?.count?.['Total Transaction'], tableData: listofdata })


        }
        else {
            const outerArray = Array.from({ length: 9 }, () => Array(30).fill(0));
            setChartDetails({ listOfFeatures: chartDetails.listOfFeatures, FeaturesData: outerArray, totalApiCalls: 0, tableData: [] })

        }
    }, [usageDetails, loading])

    useEffect(() => {
        if (!usageInfo?.app) {
            setChartDetails({ ...chartDetails, tableData: [] })
        }
    }, [usageInfo])



    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen)
    }


    const generateLabels = (from, to, intervalType, timeZone) => {
        const labels = [];
        const labelsForCsv = [];
        const start = from ? dayjs(from).clone() : null;
        const end = to ? dayjs(to).clone() : null;

        if (intervalType === 'hour' && start && end) {
            const duration = end.diff(start, 'hours');
            for (let i = 0; i <= duration; i++) {
                labels.push(start.clone().add(i, 'hours').tz(timeZone).format('MMM DD, HH:mm'));
                labelsForCsv.push(start.clone().add(i, 'hours').tz(timeZone).format('MMM DD YYYY HH:mm'));
            }
        }
        else if (intervalType === 'day') {
            const duration = end?.diff(start, 'days');
            for (let i = 0; i <= duration; i++) {
                labels.push(start?.clone().add(i, 'days').format('MMM DD, 00:00'));
                labelsForCsv.push(start?.clone().add(i, 'days').format('MMM DD YYYY 00:00'));
            }
        } else if (intervalType === 'month') {
            let startDate = from ? dayjs(from).clone().startOf('month') : null;
            let endDate = to ? dayjs(to).clone() : null;
            const duration = endDate?.diff(startDate, 'months');
            for (let i = 0; i <= duration; i++) {
                labels.push(start?.clone().add(i, 'months').startOf('month').format('MMM DD, 00:00'));
                labelsForCsv.push(start?.clone().add(i, 'months').startOf('month').format('MMM DD YYYY 00:00'));
            }
        }

        return { labels, labelsForCsv };
    };

    useEffect(() => {
        const { labels, labelsForCsv } = generateLabels(usageInfo?.from_date, usageInfo?.to_date, usageInfo?.duration, selectedTimeZone ? selectedTimeZone : timezone);
        setLabels(labels)
        setLabelsForCsv(labelsForCsv)
    }, [usageInfo?.from_date, usageInfo?.to_date, usageInfo?.duration, selectedTimeZone, timezone])


    const handleClose = () => {
        setPopupDetails({ open: false })
    }


    const handleClickAddCard = () => {
        dispatch(setPayementInformation({ from: "payment-information" }))
        navigate('/settings/billing-details')
    }

    const handleAddApp = () => {
        if (!card_setup) {
            setPopupDetails({
                open: true, titleText: `Add application`,
                bodyText: <div className="billing"><p>To add your first application, please setup your billing information.</p><span>Note: You will be charged once your trial plan ends.</span></div>,
                primaryButtonText: 'Add card', secondaryButtonText: 'Cancel', handleClickPrimaryButton: handleClickAddCard, handleClickSecondaryButton: handleClose, handleClose: handleClose
            })
        }
        else {
            navigate('/application/add-application')
        }
    }


    const timeZoneSelected = selectedTimeZone ? selectedTimeZone : timezone


    return (
        <div className="usage-container">
            <div className="duration-details-container">
                <div className="date-field">
                    <span className="label">Show last</span>
                    <div className="vertical-line"></div>
                </div>
                {timeDurationTypes.map((ele, i) => (
                    <div className={`date-field`} onClick={() => handleDurationChange(ele.value, "format")}>
                        <span className={`duration-type  ${ele.value === usageInfo?.format ? "active" : ""}`}>{ele.label}</span>
                        {(i !== timeDurationTypes.length - 1) &&
                            <div className="vertical-line"></div>}
                    </div>
                ))}

            </div>

            <div className="date-label-container">
                <div className="date-details-container">
                    <div className="date-field">
                        <span className="label">Showing data from</span>
                        <DateInput value={usageInfo?.from_date} onInputChange={onInfoChange} name="from_date" dtFormat="DD MMM YYYY" maxDate={usageInfo?.to_date} />

                    </div>
                    <div className="date-field">
                        <span className="label">until</span>
                        <DateInput value={usageInfo?.to_date} onInputChange={onInfoChange} name="to_date" dtFormat="DD MMM YYYY" minDate={usageInfo?.from_date} />
                        <div className="vertical-line"></div>


                    </div>
                    <div className="usage-duration">

                        <Dropdown
                            isOpen={isDropdownOpen}
                            toggle={() => {
                                toggleDropdown()
                            }}
                            direction="down"
                            className="custom-dropdown dropdown"

                        >

                            <DropdownToggle tag="span" className="toggle-button" >
                                <span className="dropdown-text">{usageDurationTypes.find(obj => obj.value === usageInfo?.duration) ? usageDurationTypes.find(obj => obj.value === usageInfo?.duration)?.label : ""}</span>
                                <DropdownIcon />
                            </DropdownToggle>
                            <DropdownMenu
                                className={`custom-dropdown-menu`}
                            >
                                {
                                    usageDurationTypes?.map((option) => (
                                        <DropdownItem
                                            className={`dropdown-item ${(option.value === usageInfo?.duration) ? "selected" : ""}`}
                                            key={option.label}
                                            onClick={(e) => {
                                                setTimeout(() => {
                                                    onInfoChange(option?.value, "duration")
                                                }, 1);
                                            }}
                                        >
                                            {option.label}
                                        </DropdownItem>
                                    ))}
                            </DropdownMenu>
                        </Dropdown>
                    </div>

                </div>
                {/* {tableData?.totalApiCalls?.toString() &&
                    <div className="total_count"><span >Total API calls</span> : {tableData.totalApiCalls}</div>
                } */}
            </div>
            {
                (chartDetails.FeaturesData && appsList.length !== 0 && usageInfo?.app) &&
                <UsageChart data={(chartDetails?.FeaturesData || chartDetails.totalApiCalls > 0 || !loading) ? chartDetails?.FeaturesData : []} legendsList={loading ? [] : chartDetails?.listOfFeatures} xAxisLabels={chartDetails?.totalApiCalls > 0 && !loading ? labels : []} isLoading={loading} />

            }
            {
                ((timezone || selectedTimeZone) && !loading && appsList.length !== 0 && usageInfo?.app) &&
                <div className="timezone">
                    <span>{(chartDetails?.FeaturesData.length !== 0 && !loading && chartDetails.totalApiCalls > 0) ? "" : responseMessage}</span>
                    <span>{`Using time zone (${selectedTimeZone ? selectedTimeZone : timezone})`}</span>
                </div>
            }
            <div className={`${loading || !(chartDetails && chartDetails.tableData.length !== 0 && appsList.length !== 0) ? "data-container" : "table-container"}`}>
                {loading ? (

                    <CustomLoader text={"Fetching usage details..."} />
                )
                    : !((chartDetails && chartDetails.tableData.length !== 0 && appsList.length !== 0)) ? (
                        <div className="no-data-view">
                            {emptyUsageViewIcon}
                            <span className="no-data-text">No data to show</span>
                            {
                                card_setup ?
                                    <Link to="/application/add-application">
                                        <button className="button-background">Add application</button>
                                    </Link>
                                    :
                                    <button onClick={handleAddApp} className="button-background">Add application</button>

                            }

                        </div>


                    )
                        : (
                            <table responsive className="table-custom m-0">
                                <thead>
                                    <tr className="header">
                                        {tableHeader.map(title => (
                                            <th className="title" key={Math.random()}>
                                                {title.title}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    {chartDetails.tableData.map(row => (
                                        <tr className="data" key={row.id}>
                                            {tableHeader.map((header, index) => (
                                                <td className="title">{row[header.value]}</td>

                                            ))


                                            }
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                        )}
            </div>
            {popupDetails.open &&
                <CustomPopup
                    popupDetails={popupDetails}
                />
            }
        </div >
    )
}
export default UsageTable